import { render, staticRenderFns } from "./ParthnerSlide.vue?vue&type=template&id=509876d4"
import script from "./ParthnerSlide.vue?vue&type=script&lang=js"
export * from "./ParthnerSlide.vue?vue&type=script&lang=js"
import style0 from "./ParthnerSlide.vue?vue&type=style&index=0&id=509876d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports